import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import HeaderMenu from "../../component/Navbar/headermenu";
import CustomFooter from "../../component/Footer/customFooter";
import { FeaturePageStructuredData } from "../../config/StructuredData";

const ClientWiseWorkTracking = () => (
  <>
    <FeaturePageStructuredData
      name="Client-Wise Work Tracking Software"
      description="Track every client's work by stage, owner, and status with Simplifyte. Know exactly where each GST return, income tax filing, audit, or deliverable stands — in real time."
      url="https://www.simplifyte.com/features/client-wise-work-tracking"
    />
    <HeaderMenu />
    <main style={{ paddingTop: "80px", minHeight: "100vh" }}>
      <section style={{ background: "linear-gradient(135deg,#093A5B 0%,#0a4d6e 100%)", padding: "60px 24px", color: "#fff", textAlign: "center" }}>
        <div style={{ maxWidth: "800px", margin: "0 auto" }}>
          <p style={{ fontSize: "13px", letterSpacing: "2px", textTransform: "uppercase", opacity: 0.7, marginBottom: "16px" }}>Features</p>
          <h1 style={{ fontSize: "clamp(26px,4vw,44px)", fontWeight: 700, lineHeight: 1.2, marginBottom: "20px" }}>Client-Wise Work Tracking Software</h1>
          <p style={{ fontSize: "17px", opacity: 0.85, maxWidth: "640px", margin: "0 auto 32px" }}>Know exactly where every client's work stands — by stage, owner, period, and status. No more "which stage is Mehta's GST at?" on WhatsApp.</p>
          <Link to="/contactsales" style={{ background: "#fff", color: "#093A5B", padding: "12px 28px", borderRadius: "8px", fontWeight: 600, textDecoration: "none" }}>Book a Demo</Link>
        </div>
      </section>

      <section style={{ padding: "60px 24px" }}>
        <div style={{ maxWidth: "820px", margin: "0 auto" }}>
          <h2 style={{ fontSize: "26px", fontWeight: 700, color: "#093A5B", marginBottom: "16px" }}>What is client-wise work tracking?</h2>
          <p style={{ fontSize: "16px", color: "#475569", lineHeight: 1.7, marginBottom: "16px" }}>
            In professional service firms — CA firms, tax consultants, advocates — every piece of work belongs to a specific client. Client-wise work tracking means every task is linked to a client name, has a current status, an assigned staff member, and a deadline. You can filter all work for one client or see all open items across all clients at once.
          </p>
          <p style={{ fontSize: "16px", color: "#475569", lineHeight: 1.7 }}>
            Without this, work gets tracked in Excel rows or WhatsApp messages — and status questions become daily interruptions. With Simplifyte, the status is always visible to whoever needs it.
          </p>
        </div>
      </section>

      <section style={{ padding: "40px 24px", background: "#f8fafc" }}>
        <div style={{ maxWidth: "820px", margin: "0 auto" }}>
          <h2 style={{ fontSize: "24px", fontWeight: 700, color: "#093A5B", marginBottom: "24px" }}>Before Simplifyte / With Simplifyte</h2>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
            <div style={{ background: "#fff5f5", padding: "20px", borderRadius: "10px" }}>
              <h3 style={{ color: "#ef4444", marginBottom: "12px", fontSize: "15px", fontWeight: 600 }}>Before Simplifyte</h3>
              {["Status check = WhatsApp message to staff","Excel sheet updated manually (and usually not)","No one knows who last touched the file","Partner asks team — team asks client — no answer","Missed work discovered at deadline"].map((t,i)=>(<p key={i} style={{ fontSize: "14px", color: "#64748b", marginBottom: "8px", paddingLeft: "8px", borderLeft: "2px solid #fca5a5" }}>{t}</p>))}
            </div>
            <div style={{ background: "#f0fdf4", padding: "20px", borderRadius: "10px" }}>
              <h3 style={{ color: "#16a34a", marginBottom: "12px", fontSize: "15px", fontWeight: 600 }}>With Simplifyte</h3>
              {["Real-time status visible to partner and team","Work moves through stages automatically","Every action is logged with name and timestamp","Partner sees full client workload on one screen","Nothing falls through because ownership is clear"].map((t,i)=>(<p key={i} style={{ fontSize: "14px", color: "#64748b", marginBottom: "8px", paddingLeft: "8px", borderLeft: "2px solid #86efac" }}>{t}</p>))}
            </div>
          </div>
        </div>
      </section>

      <section style={{ padding: "60px 24px", textAlign: "center", background: "#093A5B", color: "#fff" }}>
        <h2 style={{ fontSize: "26px", fontWeight: 700, marginBottom: "14px" }}>See every client's work status — always</h2>
        <Link to="/contactsales" style={{ background: "#fff", color: "#093A5B", padding: "13px 30px", borderRadius: "8px", fontWeight: 600, textDecoration: "none", display: "inline-flex", alignItems: "center", gap: "8px" }}>Book a Demo <ArrowRight size={16} /></Link>
      </section>
    </main>
    <CustomFooter />
  </>
);

export default ClientWiseWorkTracking;
